import { render, staticRenderFns } from "./TemplateListItem.vue?vue&type=template&id=6a66d98a&lang=pug&"
import script from "./TemplateListItem.vue?vue&type=script&lang=js&"
export * from "./TemplateListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports